import React, { useState, useEffect, useMemo } from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { fetchAllPages } from "../../common/tableData";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Dummy from "../../assets/images/No_Image_Available.jpg";

const DatatableTables = ({ t }) => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getBodyPartsData = async () => {
    setIsLoading(true);
    try {
      const bodyParts = await fetchAllPages(
        (page, pageSize) =>
          `category/subcategories/?page=${page}&page_size=${pageSize}`
      );
      setRows(bodyParts);
    } catch (error) {
      console.error("Error fetching subcategory data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getBodyPartsData();
  }, []);

  const handleEdit = (id) => {
    navigate(`/category/edit-sub-category/${id}`);
  };

  const tableData = useMemo(
    () => ({
      columns: [
        {
          label: t("ID"),
          field: "id",
          sort: "asc",
          width: 100,
        },
        {
          label: t("Image"),
          field: "image",
          sort: "disabled",
          searchable: false,
          width: 100,
        },
        {
          label: t("Name"),
          field: "name",
          sort: "asc",
          width: 150,
        },
        {
          label: t("Status"),
          field: "is_active",
          sort: "asc",
          width: 270,
        },
        {
          label: t("Parent Category"),
          field: "parent_category_name",
          sort: "asc",
          width: 150,
        },
        {
          label: t("Action"),
          field: "edit",
          sort: "disabled",
          searchable: false,
          width: 100,
        },
      ],
      rows: rows.map((subcategory) => ({
        id: subcategory.id,
        name: subcategory.name,
        is_active: subcategory.is_active ? t("True") : t("False"),
        image: <img src={subcategory.image || Dummy} alt="Body Part" width="50" height="50" />,
        parent_category_name: subcategory.parent_category ? subcategory.parent_category.name : "N/A",
        edit: <Button color="primary" onClick={() => handleEdit(subcategory.id)}>{t("Edit")}</Button>,
      })),
    }),
    [rows, t]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle={t("Home")} title={t("Data")} breadcrumbItem={t("Pain Area's")} />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <CardTitle className="h4 mb-0">{t("Pain Area's of body.")}</CardTitle>
                    <Button color="primary" onClick={() => navigate(`/category/create-sub-category/id`)}>
                      <i className="typcn typcn-plus me-1"></i> {t("Add New Body Part")}
                    </Button>
                  </div>

                  <MDBDataTable
                    responsive
                    striped
                    bordered
                    paging
                    searching
                    sortable
                    order={["id", "asc"]}
                    entries={10}
                    entriesOptions={[10, 25, 50, 100]}
                    displayEntries
                    info
                    infoLabel={[t("Showing"), t("to"), t("of"), t("entries")]}
                    paginationLabel={["<", ">"]}
                    searchLabel={t("Search")}
                    noRecordsFoundLabel={t(isLoading ? "Loading..." : "No records found")}
                    data={tableData}
                    className="custom-cursor-pointer"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(DatatableTables);
